import { render, staticRenderFns } from "./GameTrackingPage.vue?vue&type=template&id=56135dac&scoped=true"
import script from "./GameTrackingPage.vue?vue&type=script&lang=js"
export * from "./GameTrackingPage.vue?vue&type=script&lang=js"
import style0 from "./GameTrackingPage.vue?vue&type=style&index=0&id=56135dac&prod&scoped=true&lang=css"
import style1 from "./GameTrackingPage.vue?vue&type=style&index=1&id=56135dac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56135dac",
  null
  
)

export default component.exports